import styled from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

export const SearchInputContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 26px 14px 18px;
  width: 274px;
  border: 1px solid ${theme.colors.primary.transparentBorder};
  box-sizing: border-box;
  border-radius: 8px;
  &.SearchTable {
    max-width: 200px;
    padding: 7px 26px 7px 18px;
  }
  &:not(.SearchTable) {
    width: 274px;
  }
`;

export const Input = styled.input`
  width: 100%;
  margin-left: 16px;
  border: 0;
  outline: 0;
  box-shadow: none;
  font-size: 14px;
  &:disabled {
    cursor: not-allowed;
    border-bottom: 1px solid ${theme.colors.primary.transparentBorder} !important;
    background-color: ${theme.colors.primary.transparentBg};
    color: ${theme.colors.secondary.gray200};
  }
  &::placeholder {
    color: ${theme.colors.states.disabled};
  }
`;
